module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-barrel-12.12244b19.png";